import { Scroll } from "@lib/scroll";
import { Pages } from "@lib/pages";
import { fixStagingLinks } from "@utils/staging";

// history.scrollRestoration = "manual";

class _App {
  private scroll = Scroll;
  pages = Pages;

  constructor() {
    fixStagingLinks();
  }
}

export const App = new _App();
